import { createFeature, createReducer, on } from '@ngrx/store';
import { MessageOutboxModel } from '@shared/data-access/models';
import { MessageOutboxAction } from '../actions';

export const featureName = 'messageOutbox';

export interface DataState {
  detail: MessageOutboxModel | null;
}
export const initialState: DataState = {
  detail: null,
};
export const messageOutboxFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(MessageOutboxAction.getDetail, (state, prop: { item: MessageOutboxModel }) => ({ ...state, detail: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = messageOutboxFeature;
